import cloneDeep from 'lodash/cloneDeep'
import unescape from 'lodash/unescape'
import { ModerationStages } from '@/constants/backend/ModerationStages'
import { GigStatuses } from '@/constants/gig/gigStatuses'
import { GigTimeTypes } from '@/constants/gig/gigTimeTypes'
import Image from '@/models-ts/Image'
import Skill from '@/models-ts/Skill'
import { stripDescriptionTags } from '@/utils/contract'
import { parseSlug } from '@/utils/parser'

export default class MyGigListItem {
  id: number
  slug: string
  name: string
  created_at: string
  updated_at: string
  description: string
  rate: string
  banner: Image
  skills: Array<Skill>
  status: GigStatuses
  moderationStage: ModerationStages
  timeType: GigTimeTypes
  timeValue: string
  views: number | string

  constructor(data: Partial<MyGigListItem>) {
    Object.assign(this, cloneDeep(data))
  }

  static fromServer(data: LX.MyGigListItem) {
    return new MyGigListItem({
      id: data.id,
      created_at: data.created_at,
      updated_at: data.updated_at,
      slug: parseSlug(data.slug),
      name: unescape(data.name),
      banner: Image.fromServer(data.banners, { maxSize: 700 }),
      status: +data.status,
      moderationStage: data.moderation_stage,
      description: stripDescriptionTags(data.description),
      timeValue: String(data.time_value || 0),
      timeType: +data.time_type,
      rate: data.rate,
      skills: (data.skills || []).map(Skill.fromServer),
      views: data.views,
    })
  }

  get sortField() {
    return this.updated_at || this.created_at
  }
}
